import script from "./KeywordGroupModal.vue?vue&type=script&setup=true&lang=js"
export * from "./KeywordGroupModal.vue?vue&type=script&setup=true&lang=js"

import "./KeywordGroupModal.vue?vue&type=style&index=0&id=792ceb46&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-792ceb46"]])

export default __exports__